

























































import { Component, Model, Prop } from 'vue-property-decorator';

import Dropzone from '@/componentsV2/molecules/Dropzone/Dropzone.vue';
import PaperClip from '@/components/icons/PaperClip.vue';
import DocUploadIcon from '@/components/icons/DocUploadIcon.vue';
import CloseCircleIcon from '@/components/icons/CloseCircle.vue';
import InputBase from '@/componentsV2/molecules/Inputs/InputBase.vue';
import InputWrapper from '@/componentsV2/molecules/Inputs/InputWrapper.vue';
import Loading from '@/components/icons/Loading.vue';
import CloseCircle from '@/components/icons/CloseCircle.vue';

type DocUploadBlockValue = {
  docFile?: File | null;
  docUrl: string;
};

const initialState = () => ({ docFile: null, docUrl: '' });

@Component({
  components: {
    InputWrapper,
    Dropzone,
    PaperClip,
    DocUploadIcon,
    CloseCircleIcon,
    Loading,
    CloseCircle
  }
})
export default class DocUploadBlock extends InputBase {
  @Prop({ default: false }) isOptional?: boolean;
  @Prop({ default: false }) showHelpIcon?: boolean;
  @Prop({ default: false }) loading?: boolean;
  @Prop({ default: false }) uploadFailed?: boolean;
  @Prop({ default: false }) disabled?: boolean;
  @Model('input', {
    type: Object,
    default: initialState
  })
  value!: DocUploadBlockValue;
  nameFile: string = '';

  get labelField() {
    return this.label || this.$t(`${this.tPrefix}.label`);
  }

  get helpTextDefault() {
    return this.$t(`${this.tPrefix}.helpText`);
  }

  resetInputFile() {
    const containerEl = this.$refs.docUploadContainer as
      | HTMLElement
      | undefined;

    if (!containerEl) return;

    const inputFileEl = containerEl.querySelector<HTMLInputElement>(
      'input[type="file"]'
    );

    if (inputFileEl) {
      inputFileEl.value = '';
    }
  }

  handleReset() {
    if (this.disabled) {
      return;
    }

    this.$emit('input', initialState());
    this.resetInputFile();
  }

  get tPrefix() {
    return 'common.components.docUploadBlock';
  }

  handleDropzoneInput(files: File[]) {
    const [file] = files;

    if (!file) return;

    this.$emit('selectedFile', file);

    const supportedFileTypes = ['xlsx', 'csv'];
    if (!supportedFileTypes.some(type => file.name.split('.').includes(type))) {
      this.$notification(
        String(this.$t(`${this.tPrefix}.warnFormatFile`)),
        'warn'
      );
      return;
    }

    const sizeInMB = file.size / 1024 / 1024;

    if (sizeInMB > 10) {
      this.$notification(
        String(this.$t(`${this.tPrefix}.warnMaximumFileSize`)),
        'warn'
      );
      return;
    }

    this.nameFile = file.name;

    const docUrl = URL.createObjectURL(file);

    this.$emit('input', {
      docFile: file,
      docUrl,
      docName: this.nameFile
    });
  }
}
